import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CVesselTrackerService } from '../../../../shared/services/c-vessel-tracker.service';
import {NgbTypeaheadConfig} from '@ng-bootstrap/ng-bootstrap';
import {Observable, of} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, map, tap, switchMap} from 'rxjs/operators';
type State = {id: number, label: string};
@Component({
    selector: 'app-container-vessel-tracker',
    templateUrl: './container-vessel-tracker.component.html',
    styleUrls: ['./container-vessel-tracker.component.css'],
    providers: [NgbTypeaheadConfig],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContainerVesselTrackerComponent implements OnInit {
  model: any;
  searching = false;
  searchFailed = false;
  conainerVesselTDetails:any;
  conainerVesselname:any;
  
  constructor(config: NgbTypeaheadConfig,private cVesselTrackerService:CVesselTrackerService) {
    config.showHint = true;
  }
  iframeSrc = ''

  ngOnInit(): void {
    
  }
  
  formatter = (state: State) => state.label;
  
  search = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    tap(() => this.searching = true),
    switchMap(term =>
      this.cVesselTrackerService.search(term).pipe(
        tap(() => this.searchFailed = false),
        catchError(() => {
          this.searchFailed = true;
          return of([]);
        }))
    ),
    tap(() => this.searching = false)
    // map(term => this.states.filter(state => new RegExp(term, 'mi').test(state.name)).slice(0, 10))
  )

  onSubmit(){
    if(this.conainerVesselname && this.conainerVesselname.value){
      this.iframeSrc = '<iframe frameborder="0" height="360" id="vesselmap" style="border:0" width="100%"  src="https://www.pier2pier.com/links/trackingvessel.php?email=dsubedar@shipco.com&Client=Shipco&VesselName='+ this.conainerVesselname.value +'"></iframe>';
      let reqObj = {
        cVesselname:this.conainerVesselname.value
      }
      this.cVesselTrackerService.getContainerVesselTrackerDetails(reqObj).subscribe((res)=>{
         this.conainerVesselTDetails = [];
         this.conainerVesselTDetails = res;
      })
    }
  }
  
}
